import { Box, Container } from "@mui/material";
import React, { PropsWithChildren } from "react";
interface IPageContainer {
  // title: string;
}
export const ButtonContainer: React.FC<PropsWithChildren<IPageContainer>> = ({
  children,
}) => {
  return (
    <Container
      style={{
        // flexDirection: "row",
        // display: "flex",
        // justifySelf: "start",
        // height: 50,
        // gap: 8,
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        gap: 8,
      }}
    >
      {children}
    </Container>
  );
};
